import React, { useState} from "react";
import "./presentation.css";
import { Outlet } from "react-router-dom";
// import Events from "../pages/DashboardLayout";
import { RoleContext } from "src/contexts/context";

const App = () => {
  const [roles, setRoles] = useState([]);

  return (
    <RoleContext.Provider value={{ roles, setRoles }}>
      <Outlet></Outlet>
    </RoleContext.Provider>
  );
};

export default App;
